import { gql } from '@apollo/client';

export const GET_MEMBERS_QUERY = gql`
  query GetMembers(
    $displayName: String
    $jobTitles: [String]
    $roles: [String]
    $departments: [String]
  ) {
    getMembers(
      pagination: { skip: 0, take: 1000 }
      filter: {
        displayName: $displayName
        jobTitles: $jobTitles
        roles: $roles
        departments: $departments
      }
    ) {
      data {
        displayName
        id
        jobTitle
        providerId
        roles {
          role {
            displayName
            id
          }
        }
        departments {
          department {
            displayName
            id
          }
        }
      }
    }
  }
`;

export const GET_JOB_TITLES = gql`
  query MyQuery {
    getJobTitles
  }
`;

export const GET_SYSTEM_ROLES = gql`
  query MyQuery {
    getSystemRoles {
      displayName
      id
    }
  }
`;

export const GET_DEPARTMENTS = gql`
  query MyQuery {
    getDepartments {
      displayName
      id
    }
  }
`;

export const EDIT_MEMBERS_MUTATION = gql`
  mutation EditMembers($input: [EditMemberInput!]!) {
    editMembers(input: $input)
  }
`;
